<template>
    <div class="toplogo">
		<img src="../assets/img/bulevar.svg" alt="Bulevar Logo" />
    </div>
    <div class="language">
        <router-link lang="sl-SI" xml:lang="sl-SI" to="/login" class="button slo" @click="changeLanguage('sl')">Vstopi</router-link>
        <router-link lang="en-GB" xml:lang="en-GB" to="/login" class="button eng" @click="changeLanguage('en')">Enter</router-link>
        <router-link lang="it-IT" xml:lang="it-IT" to="/login" class="button ita" @click="changeLanguage('it')">Entrare</router-link>
    </div>
    <div class="go">
		<img src="../assets/img/GO2025-logo.svg" alt="GO2025" />
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import  axios from 'axios';

export default {
	name: 'HomePage',
	setup() {
		const { t, locale, setLocaleMessage  } = useI18n();

		const changeLanguage = async (newLocale) => {
			localStorage.setItem('lang', newLocale);
			locale.value = newLocale;
			await loadInitialLocale(newLocale);
		};
		const loadInitialLocale = async (newLocale) => {
			try {
				const response = await axios.get(`${process.env.VUE_APP_TRANSLATEAPI}${newLocale}`);
				const messages = response.data;
				
				setLocaleMessage(newLocale, messages); 
				locale.value = newLocale;

				//localStorage.setItem('lang', newLocale);
			} catch (error) {
				console.error('Error loading locale messages:', error);
			}
		};

		const savedLocale = localStorage.getItem('lang');
		loadInitialLocale(savedLocale);

		return {
			changeLanguage,
			t
		};
    },
	mounted() {
		const lang = localStorage.getItem('lang');
		if (lang) {
			this.$router.replace(`/login`);
		}
	},
	mehods: {
		
	}
};
</script>

<style>
/* Add specific styles for Home component */
</style>
